import { createReducer, on } from '@ngrx/store';

import * as CartActions from '@fcom/booking/store/actions/cart.actions';
import { updateStoreAction } from '@fcom/core/store/init-store.action';

import * as OrderActions from '../actions/order.actions';
import * as SeatMapActions from '../actions/seat-map.actions';
import { COMMON_BOOKING_FEATURE_KEY } from '../constants';
import { onSeatMapFlowReset } from './seat-map-flow-reset.on';

/**
 * Tracks whether seat selections in the store have been modified since the last
 * cart sync. This is seat-specific — it is not affected by other ancillary actions
 * that also set the global `cart.dirty` flag (e.g. meal or baggage selections).
 *
 * Set to true:  SeatMapActions.setSeatForFlight (user picks/changes a seat)
 *               SeatMapActions.clearSelections   (all seats removed)
 *               SeatMapActions.clearAllSeats     (seats removed for specific travelers)
 * Reset to false: CartActions.setCartData / SeatMapActions.loadSeatSelectionsFromCart /
 *                 SeatMapActions.resetSeatSelections (cart synced from backend)
 *                 updateStoreAction (session/localStorage rehydration, when commonBooking feature present)
 *                 OrderActions.setOrderData (order reloaded from backend)
 *                 onSeatMapFlowReset covers all booking-flow resets (mirrors seatMapReducer).
 */
export const seatsDirtyReducer = createReducer(
  false,
  on(SeatMapActions.setSeatForFlight, SeatMapActions.clearSelections, SeatMapActions.clearAllSeats, () => true),
  on(
    CartActions.setCartData,
    SeatMapActions.loadSeatSelectionsFromCart,
    SeatMapActions.resetSeatSelections,
    () => false
  ),
  on(updateStoreAction, (state, { features }) => (features.includes(COMMON_BOOKING_FEATURE_KEY) ? false : state)),
  on(OrderActions.setOrderData, () => false),
  onSeatMapFlowReset(false)
);
